"use client";

import { c as _c } from "react/compiler-runtime";
import { HiOutlineReply } from "react-icons/hi";
import { Button } from "@/components/ui";
import { EmailMessage } from "@/types/email";
interface EmailActionButtonsProps {
  message: EmailMessage;
  onReply?: (messageId: string) => void;
  onForward?: (messageId: string) => void;
  className?: string;
}
export function EmailActionButtons(t0) {
  const $ = _c(16);
  const {
    message,
    onReply,
    onForward,
    className
  } = t0;
  if (message.status === "SENDING" || message.status === "QUEUED") {
    return null;
  }
  let t1;
  if ($[0] !== message.id || $[1] !== onReply) {
    t1 = e => {
      e.stopPropagation();
      onReply?.(message.id);
    };
    $[0] = message.id;
    $[1] = onReply;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HiOutlineReply className="h-3 w-3" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <Button variant="ghost" onClick={t1} size="sm" icon={t2} aria-label="Reply to email" tooltip="Reply" />;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== message.id || $[7] !== onForward) {
    t4 = e_0 => {
      e_0.stopPropagation();
      onForward?.(message.id);
    };
    $[6] = message.id;
    $[7] = onForward;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <HiOutlineReply className="h-3 w-3 scale-x-[-1]" />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <Button variant="ghost" onClick={t4} size="sm" icon={t5} aria-label="Forward email" tooltip="Forward" />;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== className || $[13] !== t3 || $[14] !== t6) {
    t7 = <div className={className}>{t3}{t6}</div>;
    $[12] = className;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}